/**
 * Custom D2C Cart Drawer AJAX Controller for Shopify Dawn Theme
 * Supports 10%, 15%, 20%, 25% Automatic Discounts,
 * In-Cart Product Upsell Carousel (+ Add to cart),
 * and Guaranteed Sticky Checkout.
 */

const D2C_DISCOUNT_TIERS = [
  { amount: 999, pct: 10, label: '10% Off<br>Shipping Free', unlockText: '10% OFF + Free Shipping' },
  { amount: 1999, pct: 15, label: '15% Off', unlockText: '15% OFF' },
  { amount: 2999, pct: 20, label: '20% Off', unlockText: '20% OFF' },
  { amount: 3999, pct: 20, label: '20% Off + Free<br>15ml Gift', unlockText: '20% OFF + Free 15ml Gift' }
];

function formatMoney(cents) {
  const rupees = Math.round(cents / 100);
  return '₹' + rupees.toLocaleString('en-IN') + '.00';
}

// PHYSICALLY PURGE ALL NATIVE DAWN CART DRAWERS & OVERLAYS FROM DOM
function killNativeCartDrawer() {
  const nativeElements = document.querySelectorAll(
    'cart-drawer, #CartDrawer-Overlay, .cart-drawer__overlay, .drawer__overlay, cart-notification, .cart-notification'
  );
  nativeElements.forEach(el => {
    try {
      el.remove();
    } catch (e) {
      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
      el.style.setProperty('pointer-events', 'none', 'important');
      el.style.setProperty('opacity', '0', 'important');
    }
  });
}
window.killNativeCartDrawer = killNativeCartDrawer;

function openCustomCartDrawer() {
  // If user is already on the dedicated /cart page, do not pop drawer over the page
  if (window.location.pathname === '/cart' || window.location.pathname.endsWith('/cart')) {
    return;
  }

  killNativeCartDrawer();

  const drawer = document.getElementById('CustomCartDrawer');
  const overlay = document.getElementById('CustomCartDrawerOverlay');
  if (drawer && overlay) {
    drawer.classList.add('active');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';

    // Fire celebration if bundle was just added
    if (sessionStorage.getItem('just_added_bundle') === 'true') {
      sessionStorage.removeItem('just_added_bundle');
      setTimeout(fireCartConfettiShower, 320);
    }
  }

  // Notify GoKwik that cart drawer has opened
  try {
    document.dispatchEvent(new CustomEvent('cart-drawer:open'));
    document.dispatchEvent(new CustomEvent('cart:open'));
  } catch (e) {}
}
window.openCustomCartDrawer = openCustomCartDrawer;

// Cart Drawer Confetti Engine
let _cartConfettiParticles = [];
let _cartConfettiAnimId = null;

function fireCartConfettiShower() {
  const canvas = document.getElementById('CartConfettiCanvas');
  if (!canvas) return;
  const ctx = canvas.getContext('2d');
  const drawer = document.getElementById('CustomCartDrawer');
  canvas.width = drawer ? drawer.offsetWidth : 420;
  canvas.height = drawer ? drawer.offsetHeight : window.innerHeight;

  const colors = ['#fe3d00', '#ff8533', '#FFD700', '#FFFFFF', '#FF3366', '#00E5FF'];
  const centerX = canvas.width / 2;
  const centerY = Math.min(220, canvas.height * 0.35);

  for (let i = 0; i < 80; i++) {
    _cartConfettiParticles.push({
      x: centerX,
      y: centerY,
      size: Math.random() * 7 + 4,
      speedX: (Math.random() - 0.5) * 12,
      speedY: (Math.random() - 1.2) * 14,
      gravity: 0.45,
      rotation: Math.random() * 360,
      rotationSpeed: (Math.random() - 0.5) * 10,
      color: colors[Math.floor(Math.random() * colors.length)],
      alpha: 1,
      decay: Math.random() * 0.018 + 0.012
    });
  }

  if (!_cartConfettiAnimId) {
    function renderCartConfetti() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      _cartConfettiParticles.forEach((p, idx) => {
        p.x += p.speedX;
        p.y += p.speedY;
        p.speedY += p.gravity;
        p.rotation += p.rotationSpeed;
        p.alpha -= p.decay;

        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate((p.rotation * Math.PI) / 180);
        ctx.globalAlpha = Math.max(0, p.alpha);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size * 0.6);
        ctx.restore();

        if (p.alpha <= 0 || p.y > canvas.height) {
          _cartConfettiParticles.splice(idx, 1);
        }
      });

      if (_cartConfettiParticles.length > 0) {
        _cartConfettiAnimId = requestAnimationFrame(renderCartConfetti);
      } else {
        cancelAnimationFrame(_cartConfettiAnimId);
        _cartConfettiAnimId = null;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
      }
    }
    renderCartConfetti();
  }
}
window.fireCartConfettiShower = fireCartConfettiShower;

function closeCustomCartDrawer() {
  const drawer = document.getElementById('CustomCartDrawer');
  const overlay = document.getElementById('CustomCartDrawerOverlay');
  if (drawer && overlay) {
    drawer.classList.remove('active');
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  }
}
window.closeCustomCartDrawer = closeCustomCartDrawer;

// 1. FAST QUANTITY HANDLER
async function handleD2CQty(btn, itemKey, delta, isRemove = false, lineIndex = null) {
  const row = btn.closest('.cart-item-row');
  if (!row) return;

  const qtyEl = row.querySelector('.cart-qty-val');
  const priceEl = row.querySelector('.cart-current-price');
  const unitPrice = parseInt(row.dataset.price || '0', 10);
  let currentQty = qtyEl ? (parseInt(qtyEl.textContent.trim(), 10) || 1) : 1;
  let newQty = isRemove ? 0 : currentQty + delta;
  if (newQty < 0) newQty = 0;

  // Resolve lineIndex if not provided
  if (!lineIndex && row.dataset.line) {
    lineIndex = row.dataset.line;
  }
  if (!lineIndex) {
    const allRows = Array.from(document.querySelectorAll('.cart-item-row'));
    const idx = allRows.indexOf(row);
    if (idx !== -1) lineIndex = idx + 1;
  }

  // Visual removal or update
  if (newQty === 0) {
    row.style.transition = 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)';
    row.style.opacity = '0';
    row.style.transform = 'scale(0.95)';
    setTimeout(() => { if (row.parentNode) row.remove(); }, 250);
  } else {
    if (qtyEl) qtyEl.textContent = newQty;
    if (priceEl && unitPrice > 0) {
      priceEl.textContent = formatMoney(unitPrice * newQty);
    }
  }

  // Check if removing the last item in cart
  const remainingRows = Array.from(document.querySelectorAll('.cart-item-row')).filter(r => r !== row);
  const isClearingCart = (newQty === 0 && remainingRows.length === 0);

  try {
    let cart = null;

    if (isClearingCart) {
      // 100% Reliable Clear All API
      const clearRes = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' }
      });
      if (clearRes.ok) {
        cart = await clearRes.json();
      }
    }

    if (!cart) {
      // Send FormData to /cart/change.js (highest compatibility across Shopify themes)
      const formData = new FormData();
      if (itemKey) formData.append('id', itemKey);
      if (lineIndex) formData.append('line', lineIndex.toString());
      formData.append('quantity', newQty.toString());

      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      });

      if (res.ok) {
        cart = await res.json();
      } else {
        // Fallback JSON payload
        const jsonRes = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: itemKey,
            line: lineIndex ? parseInt(lineIndex, 10) : undefined,
            quantity: newQty
          })
        });
        if (jsonRes.ok) {
          cart = await jsonRes.json();
        }
      }
    }

    if (cart) {
      if (cart.item_count === 0 || isClearingCart) {
        updateDrawerUIFromCart(cart);
      } else {
        await refreshDrawerFromServer();
      }
    } else {
      if (qtyEl) qtyEl.textContent = currentQty;
      row.style.opacity = '1';
    }
  } catch (err) {
    console.error('Error changing qty:', err);
    if (qtyEl) qtyEl.textContent = currentQty;
    row.style.opacity = '1';
  }
}

// 2. UPSELL PRODUCT VARIANT & ADD HANDLER
function handleUpsellVariantChange(select) {
  const card = select.closest('.upsell-card');
  if (!card) return;
  const opt = select.options[select.selectedIndex];
  const price = opt.getAttribute('data-price');
  const compare = opt.getAttribute('data-compare');
  const priceEl = card.querySelector('.upsell-price');
  const compareEl = card.querySelector('.upsell-compare');
  const addBtn = card.querySelector('.upsell-add-btn');

  if (priceEl && price) priceEl.textContent = price;
  if (compareEl) {
    if (compare) {
      compareEl.textContent = compare;
      compareEl.style.display = 'inline';
    } else {
      compareEl.style.display = 'none';
    }
  }
  if (addBtn) {
    addBtn.setAttribute('data-variant-id', select.value);
  }
}

async function addUpsellToCart(btn, fallbackVariantId) {
  const card = btn.closest('.upsell-card');
  let variantId = fallbackVariantId;
  if (card) {
    const select = card.querySelector('.upsell-variant-select');
    if (select) {
      variantId = select.value;
    } else if (btn.getAttribute('data-variant-id')) {
      variantId = btn.getAttribute('data-variant-id');
    }
  }

  btn.classList.add('adding');
  btn.textContent = 'Adding...';

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });

    if (res.ok) {
      btn.textContent = 'Added ✓';
      btn.classList.add('added');
      setTimeout(() => {
        btn.textContent = '+ Add';
        btn.classList.remove('added');
      }, 2000);

      // Seamlessly refresh drawer items and real server offers
      await refreshDrawerFromServer();
    } else {
      btn.textContent = '+ Add';
      btn.classList.remove('adding');
    }
  } catch (err) {
    btn.textContent = '+ Add';
    btn.classList.remove('adding');
  }
}

// REAL-TIME CACHE-BUSTED DRAWER SYNC WITH SHOPIFY SERVER
async function refreshDrawerFromServer() {
  try {
    // 1. Fetch from /cart which is NEVER cached by Shopify CDN
    const bustUrl = '/cart?_ts=' + Date.now();
    let pageRes = await fetch(bustUrl, {
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache'
      }
    });
    if (!pageRes.ok) return;

    let pageHtml = await pageRes.text();
    let doc = new DOMParser().parseFromString(pageHtml, 'text/html');

    // Handle Shopify backend replica lag if item was just added
    let hasItems = doc.querySelectorAll('.cart-item-row').length > 0;
    if (!hasItems) {
      try {
        const cartJsonRes = await fetch('/cart.js?_ts=' + Date.now());
        if (cartJsonRes.ok) {
          const cartJson = await cartJsonRes.json();
          if (cartJson.item_count > 0) {
            await new Promise(r => setTimeout(r, 150));
            const retryRes = await fetch('/cart?_ts=' + Date.now(), {
              headers: { 'Cache-Control': 'no-cache, no-store, must-revalidate', 'Pragma': 'no-cache' }
            });
            if (retryRes.ok) {
              pageHtml = await retryRes.text();
              doc = new DOMParser().parseFromString(pageHtml, 'text/html');
            }
          }
        }
      } catch (e) {}
    }

    // 1. Sync Items List (instantly shows discount tags, crossed prices, offers)
    const newItems = doc.getElementById('CartDrawerItemsList');
    const curItems = document.getElementById('CartDrawerItemsList');
    if (newItems && curItems) {
      curItems.innerHTML = newItems.innerHTML;
    }

    // 2. Sync Header Count
    const newCount = doc.getElementById('CartDrawerCount');
    const curCount = document.getElementById('CartDrawerCount');
    if (newCount && curCount) {
      curCount.textContent = newCount.textContent;
    }

    // 3. Sync Milestone Subtitle Prompt
    const newPrompt = doc.getElementById('CartMilestonePrompt');
    const curPrompt = document.getElementById('CartMilestonePrompt');
    if (newPrompt && curPrompt) {
      curPrompt.innerHTML = newPrompt.innerHTML;
    }

    // 4. Sync Milestone Progress Bar & Achieved classes
    const newBar = doc.getElementById('CartProgressBar');
    const curBar = document.getElementById('CartProgressBar');
    if (newBar && curBar) {
      curBar.style.width = newBar.style.width;
    }
    for (let i = 1; i <= 4; i++) {
      const nTier = doc.getElementById('CartTier' + i);
      const cTier = document.getElementById('CartTier' + i);
      if (nTier && cTier) cTier.className = nTier.className;
    }
    const nAmts = doc.querySelectorAll('.cart-amt-item');
    const cAmts = document.querySelectorAll('.cart-amt-item');
    nAmts.forEach((amt, idx) => { if (cAmts[idx]) cAmts[idx].className = amt.className; });
    const nLbls = doc.querySelectorAll('.cart-lbl-item');
    const cLbls = document.querySelectorAll('.cart-lbl-item');
    nLbls.forEach((lbl, idx) => { if (cLbls[idx]) cLbls[idx].className = lbl.className; });

    // 5. Sync Footer (Estimated Total, Strikethrough, Saving Badge, Checkout CTA)
    const countVal = newCount ? parseInt(newCount.textContent.trim(), 10) || 0 : 0;
    const rowCount = doc.querySelectorAll('.cart-item-row').length;
    const totalCount = rowCount > 0 ? rowCount : countVal;

    const newFooter = doc.querySelector('.cart-drawer-footer');
    let curFooter = document.querySelector('.cart-drawer-footer');
    if (newFooter) {
      if (curFooter) {
        curFooter.innerHTML = newFooter.innerHTML;
        curFooter.style.display = totalCount > 0 ? 'block' : 'none';
      } else {
        const drawer = document.getElementById('CustomCartDrawer');
        if (drawer) {
          drawer.appendChild(newFooter);
          newFooter.style.display = totalCount > 0 ? 'block' : 'none';
        }
      }
    } else if (curFooter) {
      curFooter.style.display = totalCount > 0 ? 'block' : 'none';
    }

    const curClearBtn = document.getElementById('CartClearAllBtn');
    if (curClearBtn) {
      curClearBtn.style.display = totalCount > 0 ? 'inline-block' : 'none';
    }

    // 6. Sync site header cart count bubbles
    const headerBubbles = document.querySelectorAll('.cart-count-bubble, [data-cart-count], .site-header__cart-count');
    headerBubbles.forEach(el => {
      el.textContent = totalCount;
      el.style.display = totalCount > 0 ? '' : 'none';
    });
  } catch (err) {
    console.error('Error syncing cart drawer from server:', err);
  }
}
window.refreshDrawerFromServer = refreshDrawerFromServer;

// 3. DYNAMIC UI RE-RENDER WITH 10%, 15%, 20%, 25% DISCOUNTS
function updateDrawerUIFromCart(cart) {
  const subtotalRupees = cart.total_price / 100.0;

  // Header Counts
  const countEl = document.getElementById('CartDrawerCount');
  if (countEl) countEl.textContent = cart.item_count;

  const headerBubbles = document.querySelectorAll('.cart-count-bubble, [data-cart-count], .site-header__cart-count');
  headerBubbles.forEach(el => {
    el.textContent = cart.item_count;
    el.style.display = cart.item_count > 0 ? '' : 'none';
  });

  const clearAllBtn = document.getElementById('CartClearAllBtn');

  // Check Empty
  const footer = document.querySelector('.cart-drawer-footer');
  const appliedDiscountBanner = document.querySelector('.cart-applied-discount');

  if (cart.item_count === 0) {
    if (footer) footer.style.display = 'none';
    if (clearAllBtn) clearAllBtn.style.display = 'none';
    if (appliedDiscountBanner) appliedDiscountBanner.style.display = 'none';

    const progressBar = document.getElementById('CartProgressBar');
    if (progressBar) progressBar.style.width = '0%';

    D2C_DISCOUNT_TIERS.forEach((tier, idx) => {
      const num = idx + 1;
      const tierEl = document.getElementById(`CartTier${num}`);
      const amtEl = document.querySelectorAll('.cart-amt-item')[idx];
      const lblEl = document.querySelectorAll('.cart-lbl-item')[idx];
      if (tierEl) tierEl.classList.remove('achieved');
      if (amtEl) amtEl.classList.remove('achieved');
      if (lblEl) lblEl.classList.remove('achieved');
    });

    const promptEl = document.getElementById('CartMilestonePrompt');
    if (promptEl) {
      promptEl.innerHTML = `Add <span class="highlight">₹999.00</span> to unlock <strong>10% OFF + Free Shipping</strong>`;
    }

    const container = document.getElementById('CartDrawerItemsList');
    if (container) {
      container.innerHTML = `
        <div class="cart-empty-state">
          <div class="empty-icon">🛍️</div>
          <h3>Your cart is empty</h3>
          <p>Looks like you haven't added anything to your cart yet.</p>
          <a href="/collections/all" class="cart-shop-now-btn">Start Shopping</a>
        </div>
      `;
    }
    return;
  } else {
    if (footer) footer.style.display = 'block';
    if (clearAllBtn) clearAllBtn.style.display = 'inline-block';
  }

  // Calculate Tier Eligible Subtotal (Excluding 15ml and Custom Bundle Boxes so bundle does not falsely inflate or conflict with discount tiers)
  let tierSubtotalRupees = 0;
  if (cart.items && cart.items.length > 0) {
    cart.items.forEach(item => {
      const titleLower = (item.title || item.product_title || '').toLowerCase();
      const variantLower = (item.variant_title || '').toLowerCase();
      const is15ml = titleLower.includes('15ml') || titleLower.includes('15 ml') || variantLower.includes('15ml') || variantLower.includes('15 ml');
      const isBundle = titleLower.includes('bundle box') || titleLower.includes('byob') || (item.properties && item.properties['_bundle_id']);
      if (!is15ml && !isBundle) {
        tierSubtotalRupees += (item.original_line_price || (item.original_price * item.quantity)) / 100.0;
      }
    });
  }

  // Calculate 10%, 15%, 20% Discount based on tierSubtotalRupees
  let activeDiscountPct = 0;
  if (tierSubtotalRupees >= 3999) {
    activeDiscountPct = 20;
  } else if (tierSubtotalRupees >= 2999) {
    activeDiscountPct = 20;
  } else if (tierSubtotalRupees >= 1999) {
    activeDiscountPct = 15;
  } else if (tierSubtotalRupees >= 999) {
    activeDiscountPct = 10;
  }

  // Milestone Progress Bar (Piecewise progress between milestone nodes)
  const progressBar = document.getElementById('CartProgressBar');
  if (progressBar) {
    let progressPct = 0;
    if (tierSubtotalRupees >= 3999) {
      progressPct = 100;
    } else if (tierSubtotalRupees >= 2999) {
      progressPct = 66.6 + ((tierSubtotalRupees - 2999) / 1000) * 33.4;
    } else if (tierSubtotalRupees >= 1999) {
      progressPct = 33.3 + ((tierSubtotalRupees - 1999) / 1000) * 33.3;
    } else if (tierSubtotalRupees >= 999) {
      progressPct = ((tierSubtotalRupees - 999) / 1000) * 33.3;
    } else {
      progressPct = 0;
    }
    progressBar.style.width = Math.min(100, Math.max(0, progressPct)) + '%';
  }

  // Tiers achieved state
  D2C_DISCOUNT_TIERS.forEach((tier, idx) => {
    const num = idx + 1;
    const tierEl = document.getElementById(`CartTier${num}`);
    const amtEl = document.querySelectorAll('.cart-amt-item')[idx];
    const lblEl = document.querySelectorAll('.cart-lbl-item')[idx];

    if (tierSubtotalRupees >= tier.amount) {
      if (tierEl) tierEl.classList.add('achieved');
      if (amtEl) amtEl.classList.add('achieved');
      if (lblEl) lblEl.classList.add('achieved');
    } else {
      if (tierEl) tierEl.classList.remove('achieved');
      if (amtEl) amtEl.classList.remove('achieved');
      if (lblEl) lblEl.classList.remove('achieved');
    }
  });

  // Milestone Subtitle Prompt
  const promptEl = document.getElementById('CartMilestonePrompt');
  if (promptEl) {
    let nextTier = D2C_DISCOUNT_TIERS.find(t => tierSubtotalRupees < t.amount);
    if (nextTier) {
      const diff = (nextTier.amount - tierSubtotalRupees).toFixed(2);
      promptEl.innerHTML = `Add <span class="highlight">₹${diff}</span> to unlock <strong>${nextTier.unlockText}</strong>`;
    } else {
      promptEl.innerHTML = `🎉 <strong>Congratulations!</strong> You unlocked 20% OFF + Free 15ml Gift!`;
    }
  }

  // Real Pricing directly from Shopify Session (Zero Mismatch with GoKwik Checkout)
  const realFinalPayable = cart.total_price / 100.0;
  const realOriginalPrice = cart.original_total_price ? (cart.original_total_price / 100.0) : realFinalPayable;
  const realTotalSavings = cart.total_discount ? (cart.total_discount / 100.0) : Math.max(0, realOriginalPrice - realFinalPayable);

  const finalPriceEl = document.querySelector('.cart-total-final');
  if (finalPriceEl) finalPriceEl.textContent = '₹' + Math.round(realFinalPayable).toLocaleString('en-IN') + '.00';

  const strikePriceEl = document.querySelector('.cart-total-strikethrough');
  if (strikePriceEl) {
    if (realTotalSavings > 0) {
      strikePriceEl.textContent = '₹' + Math.round(realOriginalPrice).toLocaleString('en-IN') + '.00';
      strikePriceEl.style.display = 'inline-block';
    } else {
      strikePriceEl.style.display = 'none';
    }
  }

  // Update Black Saving Badge (100% Real Shopify Savings)
  const savingPill = document.querySelector('.saving-pill-badge');
  if (savingPill) {
    if (realTotalSavings > 0) {
      savingPill.textContent = '₹' + Math.round(realTotalSavings).toLocaleString('en-IN') + '.00 Saved so far!';
      savingPill.style.display = 'inline-block';
    } else {
      savingPill.style.display = 'none';
    }
  }

  // Update applied discount banner visibility and savings
  if (appliedDiscountBanner) {
    if (realTotalSavings > 0) {
      appliedDiscountBanner.style.display = 'flex';
      const discountSavedPill = document.querySelector('.discount-saved-pill');
      if (discountSavedPill) {
        discountSavedPill.textContent = 'Saving ₹' + Math.round(realTotalSavings).toLocaleString('en-IN') + '.00';
      }
    } else {
      appliedDiscountBanner.style.display = 'none';
    }
  }

  // Update EMI text in cart drawer
  const cartEmiText = document.getElementById('CartDrawerEmiText');
  if (cartEmiText) {
    if (realFinalPayable > 0) {
      const emiMo = Math.round(realFinalPayable / 3);
      cartEmiText.innerHTML = `EMI available from <strong>₹${emiMo.toLocaleString('en-IN')}/mo</strong> on cards & UPI`;
    } else {
      cartEmiText.textContent = `EMI available on credit/debit cards & UPI`;
    }
  }

  // DYNAMIC BUNDLE COMPLETION CELEBRATION IN CART
  let hasBundleBox = false;
  if (cart && cart.items && cart.items.length > 0) {
    hasBundleBox = cart.items.some(it => {
      const titleLower = (it.title || it.product_title || '').toLowerCase();
      const props = it.properties || {};
      return titleLower.includes('bundle box') || titleLower.includes('byob') || !!props['_bundle_id'];
    });
  }

  const celebrationHero = document.getElementById('CartCelebrationHero');
  const gokwikBtn = document.getElementById('CustomGoKwikCheckoutBtn');

  if (hasBundleBox) {
    if (celebrationHero) {
      celebrationHero.style.display = 'block';
    }
    if (gokwikBtn) {
      gokwikBtn.classList.add('pulse-glow-btn');
    }
  } else {
    if (celebrationHero) {
      celebrationHero.style.display = 'none';
    }
    if (gokwikBtn) {
      gokwikBtn.classList.remove('pulse-glow-btn');
    }
  }
}

// Clear Entire Cart Function
async function clearD2CCart() {
  const clearBtn = document.getElementById('CartClearAllBtn');
  if (clearBtn) {
    clearBtn.textContent = 'Clearing...';
    clearBtn.disabled = true;
  }

  try {
    const res = await fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' }
    });

    if (res.ok) {
      const cart = await res.json();
      updateDrawerUIFromCart(cart);
    } else {
      window.location.reload();
    }
  } catch (err) {
    console.error('Error clearing cart:', err);
    window.location.reload();
  } finally {
    if (clearBtn) {
      clearBtn.textContent = 'Empty Cart';
      clearBtn.disabled = false;
    }
  }
}
window.clearD2CCart = clearD2CCart;


// 4. DISCOUNT COUPON HANDLER
async function applyCustomDiscount() {
  const input = document.getElementById('CustomCartCoupon');
  if (!input) return;
  const code = input.value.trim();
  if (!code) {
    alert("Please enter a discount code");
    return;
  }

  const btn = document.querySelector('.cart-discount-apply-btn');
  if (btn) {
    btn.disabled = true;
    btn.textContent = 'Applying...';
  }

  try {
    await fetch('/discount/' + encodeURIComponent(code));
    await refreshDrawerFromServer();
  } catch (err) {
    console.error('Error applying coupon:', err);
  } finally {
    if (btn) {
      btn.disabled = false;
      btn.textContent = 'Apply';
    }
  }
}

// 5. EVENT LISTENERS & AJAX INTERCEPTORS
document.addEventListener('DOMContentLoaded', () => {
  // 1. Immediately purge native drawers from DOM
  killNativeCartDrawer();

  // 2. Watch for dynamic injection of Dawn's native cart-drawer and remove it immediately
  try {
    const purgeObserver = new MutationObserver(() => {
      const native = document.querySelector('cart-drawer, #CartDrawer-Overlay, .cart-drawer__overlay, .drawer__overlay');
      if (native) {
        killNativeCartDrawer();
      }
    });
    purgeObserver.observe(document.body, { childList: true, subtree: true });
  } catch(e) {}

  // 3. Cart icon and trigger buttons
  const isDedicatedCartPage = window.location.pathname === '/cart' || window.location.pathname.endsWith('/cart');
  if (!isDedicatedCartPage) {
    const cartTriggers = document.querySelectorAll('a[href="/cart"], #cart-icon-bubble, .header__icon--cart, [data-cart-drawer-trigger]');
    cartTriggers.forEach(el => {
      el.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        openCustomCartDrawer();
        await refreshDrawerFromServer();
      }, true);
    });
  }

  // Intercept Native Form Submissions
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    e.preventDefault();
    e.stopPropagation();

    const submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    try {
      const formData = new FormData(form);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      });

      if (res.ok) {
        openCustomCartDrawer();
        await refreshDrawerFromServer();
      } else {
        form.submit();
      }
    } catch (err) {
      form.submit();
    } finally {
      if (submitBtn) submitBtn.disabled = false;
    }
  }, true);

  // Theme & app custom cart events
  ['cart:updated', 'cart:refresh', 'cart-drawer:refresh'].forEach(evtName => {
    document.addEventListener(evtName, () => {
      openCustomCartDrawer();
      refreshDrawerFromServer();
    });
  });
});

// Intercept all fetch calls to /cart/add (Quick View, sticky ATC, collection cards)
(function() {
  const originalFetch = window.fetch;
  window.fetch = async function(...args) {
    const res = await originalFetch.apply(this, args);
    try {
      const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url ? args[0].url : '');
      if (typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/add.js'))) {
        if (res.ok) {
          setTimeout(() => {
            openCustomCartDrawer();
            refreshDrawerFromServer();
          }, 150);
        }
      }
    } catch (e) {}
    return res;
  };

  // Intercept XMLHttpRequest for add to cart (used by legacy apps / mobile quick buy)
  const origOpen = XMLHttpRequest.prototype.open;
  const origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(method, url) {
    this._url = url;
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function() {
    this.addEventListener('load', function() {
      try {
        if (this._url && typeof this._url === 'string' && (this._url.includes('/cart/add') || this._url.includes('/cart/add.js'))) {
          if (this.status >= 200 && this.status < 300) {
            setTimeout(() => {
              openCustomCartDrawer();
              refreshDrawerFromServer();
            }, 150);
          }
        }
      } catch (e) {}
    });
    return origSend.apply(this, arguments);
  };
})();

// 6. GOKWIK FAST CHECKOUT HANDLER (Mobile & Desktop)
function handleGoKwikCheckout(btn) {
  // 1. Direct GoKwik SDK trigger with merchant credentials
  if (window.gokwikSdk && typeof window.gokwikSdk.initCheckout === 'function') {
    try {
      window.gokwikSdk.initCheckout(window.merchantInfo || {});
      return false;
    } catch (e) {
      console.warn('GoKwik SDK error', e);
    }
  }

  // 2. Global helper triggers
  if (typeof window.gokwikCheckout === 'function') {
    try {
      window.gokwikCheckout();
      return false;
    } catch (e) {}
  }

  if (typeof window.initiateGokwikCheckout === 'function') {
    try {
      window.initiateGokwikCheckout();
      return false;
    } catch (e) {}
  }

  // 3. Fallback to Shopify Direct Checkout (Guaranteed to open checkout on Mobile & Desktop)
  const form = document.getElementById('CustomCartDrawerForm') || (btn && btn.closest('form'));
  if (form) {
    let checkoutInput = form.querySelector('input[name="checkout"]');
    if (!checkoutInput) {
      checkoutInput = document.createElement('input');
      checkoutInput.type = 'hidden';
      checkoutInput.name = 'checkout';
      checkoutInput.value = '1';
      form.appendChild(checkoutInput);
    }
    form.action = '/checkout';
    form.submit();
    return false;
  }
  window.location.href = '/checkout';
  return false;
}

window.handleGoKwikCheckout = handleGoKwikCheckout;
